// React
import React from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Style
import { withNamespaces } from "react-i18next";
import styles from "./Footer.css";
// i18n

function Footer({ isLoading, onLoadButtonClick, t }) {
  return (
    <div style={styles.footer}>
      <button className="btn btn-primary" onClick={onLoadButtonClick}>
        {t("modules.localization.register.authenticated.exams.loadMore")}{" "}
        {isLoading ? (
          <i className="fa fa-refresh fa-spin" />
        ) : (
          <i className="icon-append fa fa-arrow-down" />
        )}
      </button>
    </div>
  );
}

Footer.defaultProps = {
  onLoadButtonClick: () => {}
};

Footer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onLoadButtonClick: PropTypes.func
};

const mapStateToProps = (state) => ({
  isLoading: state.exams.isLoading
});

export default compose(
  connect(mapStateToProps),
  withNamespaces()
)(Footer);
